import esriConfig from '@arcgis/core/config';

/**
 * Configure Esri Maps
 * @param apiKey Esri Maps API key
 */
export const configureEsriMaps = (apiKey: string) =>
  (esriConfig.apiKey = apiKey);
